export default {
  hasLocations(state: ProjectsState) {
    return state.suggestedLocations.length > 0 && state.listViewIsAToZ === false;
  },
  hasProjects(state: ProjectsState) {
    return state.suggestedProjects.length > 0;
  },
  hasSelectedFeature(state: ProjectsState) {
    return Object.keys(state.selectedFeatureSummary).length > 0;
  },
  hasSelectedLocation(state: ProjectsState) {
    return state.selectedLocation.magicKey !== '' && state.selectedLocation.text !== '';
  },
  hasSuggestions(state: ProjectsState) {
    return state.suggestedLocations.length > 0 || state.suggestedProjects.length > 0;
  },
  isListView(state: ProjectsState) {
    return state.projectsList.length > 0;
  },
  selectedFeature(state: ProjectsState) {
    return state.selectedFeatureSummary;
  },
};
